import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { keyService } from '../api-services/keycloak/service/key.service';

@Component({
  selector: 'app-request-error',
  templateUrl: './request-error.component.html',
  styleUrls: ['./request-error.component.css']
})
export class RequestErrorComponent implements OnInit {
  error:any;
  message:any;

  constructor(private route: ActivatedRoute,private keycloak: keyService) {
    this.route.queryParams.subscribe(params => {
      this.error = params['error'];
      this.message = params['message'];
    });
  }

  ngOnInit(): void {
  }

  signLogin(){
    this.keycloak.login();
  }

}
